import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import FadeIn from './animations/FadeIn';

interface HeroProps {
  className?: string;
}

const Hero: React.FC<HeroProps> = ({ className }) => {
  return (
    <section className={cn('relative min-h-screen flex items-center overflow-hidden', className)}>
      <div className="absolute inset-0 -z-10">
        <Image 
          src="/valentine-hero.jpg" 
          alt="Romantic Valentine's couple with heart balloons at sunset" 
          fill
          className="object-cover"
          priority
          unoptimized
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 py-20 md:py-32 relative z-10 max-w-4xl">
        <div className="max-w-3xl mx-auto text-center">
          <FadeIn delay={200}>
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-serif font-bold tracking-tight text-white leading-tight mb-6 drop-shadow-lg">
              Custom Sparks<br />
              <span className="text-pink-300">Websites</span> ❤️
            </h1>
          </FadeIn>
          
          <FadeIn delay={300}>
            <p className="text-xl md:text-2xl text-white/95 mb-4 font-medium drop-shadow-md">
              Create the perfect romantic proposal website
            </p>
            <p className="text-lg md:text-xl text-white/90 mb-8 drop-shadow-md">
              Personalized, beautiful, and unforgettable Sparks experiences
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/#showcase"
                className="bg-white/10 text-white border border-white/20 hover:bg-white/20 px-8 py-3 rounded-md font-medium transition-all"
              >
                See Example
              </Link>
              <Link
                href="/#contact"
                className="bg-white text-gray-900 hover:bg-white/90 px-8 py-3 rounded-md font-medium transition-all"
              >
                Order Your Website
              </Link>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Hero;
